export default {
  websiteBaseUrl: 'http://roomvu.loc:8000',
  apiBaseUrl: 'http://roomvu.loc:8000/api',
  dashboardBaseUrl: 'http://roomvu.loc:8000/dashboard',
  useProxyForApiCall: false,
  auth: {
    loginUrl: 'http://roomvu.loc:8000/login',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  facebook: {
    appId: '1199755590502559',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'staging',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  webEngage: {
    licenseCode: '82617805',
  },
};
